import MUITableFooter from '@mui/material/TableFooter'
import TableRow from '@mui/material/TableRow'
import { enhancedTableStyles as styles } from 'src/components/shared/EnhancedTable/EnhancedTableStyles'
import TablePagination from './TablePagination'
import TablePaginationActions from './TablePaginationActions'

type Props = {
  data: any
  pageSize: number
  pageIndex: number
  gotoPage: (pageIndex: number) => void
  setPageSize: (pageSize: number) => void
}

export default function TableFooter(props: Props): JSX.Element {
  const { data, pageSize, pageIndex, gotoPage, setPageSize } = props

  const handleChangePage = (event, newPage) => {
    gotoPage(newPage)
  }

  const handleChangeRowsPerPage = event => {
    setPageSize(Number(event.target.value))
  }

  if (data && data.length >= 0) {
    return (
      <MUITableFooter sx={styles.footer}>
        <TableRow>
          <TablePagination
            rowsPerPageOptions={[5, 10, 25, 50]}
            colSpan={3}
            count={data.length}
            labelRowsPerPage="Registros por pág."
            rowsPerPage={pageSize}
            page={pageIndex}
            SelectProps={{
              inputProps: { 'aria-label': 'registros por página' },
              native: false
            }}
            onChangePage={handleChangePage}
            onChangeRowsPerPage={handleChangeRowsPerPage}
            ActionsComponent={TablePaginationActions}
          />
        </TableRow>
      </MUITableFooter>
    )
  }
  return <></>
}
